import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);
const screens = Object.keys(fullConfig.theme.screens).reverse();

function init() {
  screens.forEach(function(el) {
    const mql = window.matchMedia('(min-width: '+ fullConfig.theme.screens[el] +')');
    if(mql.matches) {
      document.querySelector("html").classList.add(el);
    }
  });
}

window.onresize = init;
init();

/**
 *
 * @returns {string}
 */
export function getScreenSize() {
  for(let i = 0; i < screens.length; i++) {
    const html = document.querySelector("html");
    if(html.classList.contains(screens[i])) {
      return screens[i];
    }
  }
  return "sm";
}
